import React from 'react'
import useMfaLoginPage from './hooks/useMfaLoginPage'
import LoginShell from './shared/LoginShell'
import MfaLoginForm from './shared/MfaLoginForm'

function getMfaSubtitle({ useRecoveryCode, verificationMethod, destinationHint }) {
  if (useRecoveryCode) {
    return 'Ingresa uno de tus códigos de respaldo para continuar.'
  }

  if (!verificationMethod) {
    return 'Elige cómo quieres verificarte.'
  }

  if (verificationMethod === 'email') {
    return destinationHint
      ? `Te enviamos un código a ${destinationHint}.`
      : 'Te enviamos un código a tu correo.'
  }

  return 'Ingresa el código de tu aplicación de verificación.'
}

export default function MfaLoginPage() {
  const {
    otpCode,
    setOtpCode,
    recoveryCode,
    setRecoveryCode,
    useRecoveryCode,
    toggleRecoveryCode,
    rememberDevice,
    setRememberDevice,
    rememberDeviceAvailable,
    rememberDeviceDays,
    verificationMethod,
    emailCodeSent,
    destinationHint,
    totpAvailable,
    emailAvailable,
    resendBusy,
    useAuthenticator,
    useEmailCode,
    resendEmailCode,
    isSubmitting,
    verifyMfa,
    backToCredentials,
    alertId,
    formAlertMessage,
    formAlertSeverity,
    clearLoginAlert
  } = useMfaLoginPage()

  const subtitle = getMfaSubtitle({ useRecoveryCode, verificationMethod, destinationHint })

  return (
    <LoginShell eyebrow="Bienvenido de nuevo" title="Verificación en dos pasos" subtitle={subtitle}>
      <MfaLoginForm
        otpCode={otpCode}
        setOtpCode={setOtpCode}
        recoveryCode={recoveryCode}
        setRecoveryCode={setRecoveryCode}
        isSubmitting={isSubmitting}
        onSubmit={verifyMfa}
        onBack={backToCredentials}
        useRecoveryCode={useRecoveryCode}
        onToggleRecoveryCode={toggleRecoveryCode}
        rememberDevice={rememberDevice}
        setRememberDevice={setRememberDevice}
        rememberDeviceAvailable={rememberDeviceAvailable}
        rememberDeviceDays={rememberDeviceDays}
        verificationMethod={verificationMethod}
        emailCodeSent={emailCodeSent}
        destinationHint={destinationHint}
        totpAvailable={totpAvailable}
        emailAvailable={emailAvailable}
        onUseAuthenticator={useAuthenticator}
        onUseEmailCode={useEmailCode}
        onResendEmailCode={() => resendEmailCode()}
        resendBusy={resendBusy}
        formAlertId={alertId}
        formAlertSeverity={formAlertSeverity}
        formAlertMessage={formAlertMessage}
        onClearFormAlert={clearLoginAlert}
      />
    </LoginShell>
  )
}
